var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import ReactModal from 'react-bootstrap/Modal';
var HOModal = /** @class */function (_super) {
  __extends(HOModal, _super);
  function HOModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      show: false
    };
    _this.handleClose = function () {
      _this.setState({
        show: false
      });
    };
    _this.handleShow = function () {
      _this.setState({
        show: true
      });
      _this.props.showModal();
    };
    return _this;
  }
  HOModal.prototype.render = function () {
    var show = this.props.show || this.state.show;
    return React.createElement(React.Fragment, null, React.createElement(ReactModal, {
      show: show,
      onHide: this.handleClose
    }, React.createElement(ReactModal.Header, {
      closeButton: true
    }, React.createElement(ReactModal.Title, null, "Modal heading")), React.createElement(ReactModal.Body, null, "Woohoo, you're reading this text in a modal!"), React.createElement(ReactModal.Footer, null, React.createElement(Button
    // @ts-ignore
    , {
      // @ts-ignore
      variant: 'black',
      onClick: this.handleClose
    }, "Close"), React.createElement(Button, {
      variant: 'primary',
      onClick: this.handleClose
    }, "Save Changes"))));
  };
  return HOModal;
}(Component);
export { HOModal };